// import React, { useEffect } from "react";
// import WOW from "wow.js";
// import "animate.css";
// import { Link } from "react-router-dom";

// const Section = ({ evenData }) => {
//   useEffect(() => {
//     new WOW().init();
//   }, []);

//   return (
//     <section className="leadership about-area fpt-70">
//       <div className="container">
//         <div className="row">
          
//           {/* TEXT CARD */}
//           <div className="col-lg-6 order-lg-last">
//             <div
//               className="cards parentcard cardWidth bg-white p-4 wow fadeInLeftBig"
//               data-wow-duration="1s"
//             >
//               <div className="section-title">
//                 <div className="line"></div>
//                 <h3 className="title">
//                   {evenData.Title1}
//                   {evenData.Title2 && <span> {evenData.Title2}</span>}
//                 </h3>
//               </div>

//               <p className="text">{evenData.text}</p>

//               <Link to={evenData.path}>
//                 <p className="main-btn">Features</p>
//               </Link>
//             </div>
//           </div>

//           {/* IMAGE (UNCHANGED) */}
//           <div className="col-lg-6 order-lg-first">
//             <div
//               className="about-image text-center mt-50 wow fadeInRightBig"
//               data-wow-duration="1s"
//             >
//               <img
//                 className="img-fluid section-img"
//                 src={evenData.image}
//                 alt="product"
//               />
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section;

import React, { useEffect } from "react";
import WOW from "wow.js";
import "animate.css";
import { Link } from "react-router-dom";

const Section = ({ evenData }) => {
  useEffect(() => {
    new WOW().init();
  }, []);

  return (
    <section className="leadership about-area fpt-70">
      <div className="container">
        <div className="row">
          
          {/* TEXT CARD */}
          <div className="col-lg-6 order-lg-last">
            <div
              className="cards parentcard cardWidth bg-white p-4 wow fadeInLeftBig"
              data-wow-duration="1s"
            >
              <div className="section-title">
                <div className="line"></div>
                <h3 className="title">
                  {evenData.Title1}
                  {evenData.Title2 && <span> {evenData.Title2}</span>}
                </h3>
              </div>

              <p className="text" style={{ textAlign: 'justify', lineHeight: '1.8', color: '#555' }}>
                {evenData.text || ""}
              </p>

              <Link to={evenData.path}>
                <p className="main-btn">Features</p>
              </Link>
            </div>
          </div>

          {/* IMAGE */}
          <div className="col-lg-6 order-lg-first">
            <div
              className="about-image text-center mt-50 wow fadeInRightBig"
              data-wow-duration="1s"
            >
              <img
                className="img-fluid section-img"
                src={evenData.image}
                alt="product"
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Section;
